const state = {
  userInfo: null,
  authStatus: 'NO',
  creditInfo: null,
  organizations: null,
  financeProductTypes: null,
  combobox: null,
  comboboxFinance: null,
  chinagoodsGroup: {},
  options: {}
}

const getters = {
  userInfo: (state) => state.userInfo,
  authStatus: (state) => state.authStatus,
  creditInfo: (state) => state.creditInfo,
  organizations: (state) => state.organizations,
  financeProductTypes: (state) => state.financeProductTypes,
  combobox: (state) => state.combobox,
  comboboxFinance: (state) => state.comboboxFinance,
  chinagoodsGroup: (state) => state.chinagoodsGroup,
  payModeOptions: (state) => state.options['payMode_options'] || [],
  usageInfOptions: (state) => state.options['usageInf_options'] || []
}

const mutations = {
  updateUserInfo(state, obj) {
    state.userInfo = obj
  },
  updateAuthStatus(state, status) {
    state.authStatus = status
  },
  updateCreditInfo(state, obj) {
    state.creditInfo = obj
  },
  updateOrganizations(state, obj) {
    state.organizations = obj
  },
  updateFinanceProductTypes(state, obj) {
    state.financeProductTypes = obj
  },
  updateCombobox(state, box) {
    state.combobox = box
  },
  updateComboboxFinance(state, box) {
    state.comboboxFinance = box
  },
  updateChinagoodsGroup(state, { key, data }) {
    const temp = state.chinagoodsGroup
    temp[key] = data
    state.chinagoodsGroup = { ...temp }
  },
  updateOptions(state, { type, options }) {
    const temp = state.options
    temp[type] = options
    state.options = { ...temp }
  }
}

const actions = {
  updateUserInfo({ commit }, data = {}) {
    commit('updateUserInfo', data)
  },
  updateAuthStatus({ commit }, status = 'NO') {
    commit('updateAuthStatus', status)
  },
  updateCreditInfo({ commit }, data = {}) {
    commit('updateCreditInfo', data)
  },
  updateOrganizations({ commit }, data = {}) {
    commit('updateOrganizations', data)
  },
  updateFinanceProductTypes({ commit }, data = {}) {
    commit('updateFinanceProductTypes', data)
  },
  updateCombobox({ commit }, data = {}) {
    commit('updateCombobox', data)
  },
  updateComboboxFinance({ commit }, data = {}) {
    commit('updateComboboxFinance', data)
  },
  updateChinagoodsGroup({ commit }, { key = '1-2', data = [] }) {
    commit('updateChinagoodsGroup', { key, data })
  },
  updateOptions({ commit }, { type = '', options = [] }) {
    commit('updateOptions', { type, options })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
